// extracted by mini-css-extract-plugin
export default {"form":"UQWKI","inner":"mFfs7","actions":"yphsg","action":"d_ONz"};